<template>
  <LoadingWrapper :state="status">
    <SideBarLayoutContent>
      <template #top-bar>
        <div class="flex flex-row items-center gap-2">
          <BackButton
            backup-route-name="coachee"
            :params="{ id: coachee?.id }"
            icon="arrow_back"
            close
            class="mr-2 -ml-2"
          />
          <span class="text-headline-medium">{{
            coachee ? memberFullName(coachee) : ''
          }}</span>
          <BaseIcon>chevron_right</BaseIcon>
          <h1 class="text-headline-medium grow">
            {{ $t('coaching.finishedDialogs') }}
          </h1>
        </div>
      </template>

      <ul v-if="dialogList.length" class="flex flex-col gap-0.5">
        <ConductedDialogItem
          v-for="dialog in dialogList.filter((dialog) => dialog.phase === DialogPhase.Conducted)"
          :key="dialog.id"
          :conducted-dialog="dialog"
          @click="navigateToDialog(dialog.id)"
        />
      </ul>

      <EmptyPage
        v-else
        :title="$t('coaching.finishedDialogsEmpty.title')"
        :description="$t('coaching.finishedDialogsEmpty.description')"
        icon="chat"
      />
    </SideBarLayoutContent>
  </LoadingWrapper>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import ConductedDialogItem from '@/modules/dialog/components/ConductedDialogItem.vue'
  import { useCoacheePassedDialogs } from '../composables/use-coachee-passed-dialogs'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { DialogPhase } from '@/core/models/dialog/dialog'
  import BackButton from '@/core/components/BackButton.vue'
  import { memberFullName } from '@/core/models/member/member-name'

  const router = useRouter()
  const { dialogs, status } = useCoacheePassedDialogs()
  const dialogList = computed(() => dialogs.value ?? [])

  const navigateToDialog = (dialogId: string) => {
    router.push({ name: 'dialog', params: { id: dialogId } })
  }

  const coachee = computed(() => dialogs.value?.[0]?.coachee)
</script>
